import { ATTRIBUTION_MODELS, ATTRIBUTION_MODEL_LABELS, type AttributionModel } from '@/api/types'

/** The TmT attribution-model selector, shared by Advertising and Attribution; the
 * date range and comparison stay the global filter bar's. */
export function ModelSelect({ value, onChange }: { value: AttributionModel; onChange: (next: AttributionModel) => void }) {
  return (
    <label className="ci-field ci-field--inline">
      <span>TmT model</span>
      <select value={value} onChange={(event) => onChange(event.target.value as AttributionModel)}>
        {ATTRIBUTION_MODELS.map((option) => (
          <option key={option} value={option}>
            {ATTRIBUTION_MODEL_LABELS[option]}
          </option>
        ))}
      </select>
    </label>
  )
}
